import * as React from 'react';
import {List, ListItem, ListItemAvatar, ListItemText, Avatar, ListItemIcon} from "@mui/material";
import {Instagram, YouTube, Twitter, Facebook, Paid, Web} from "@mui/icons-material";
import TwitchIcon from "@/pages/TwitchIcon";

const ICON_MAP = {
    instagram: Instagram,
    youtube: YouTube,
    facebook: Facebook,
    twitter: Twitter,
    twitch: TwitchIcon,
    phone: Paid,
    iframe: Web,
}

export const Labels = ({ config, color }) => {
    return (
        <List sx={{ width: '100%' }} dense>
            {
                config.form.filter((field) => field.type === 'input' && field.value).map((field) => {
                    const Icon = ICON_MAP[field.name]

                    return (
                        <ListItem disableGutters sx={{
                            color: '#ffffff'
                        }}>
                            <ListItemAvatar>
                                <Avatar sx={{
                                    color: '#ffffff',
                                    background: color,
                                    boxShadow: `0px 0px 12.362px ${color}`}}>
                                    <Icon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={field.value} />
                        </ListItem>
                    )
                })
            }
        </List>
    );
}